module.exports = __webpack_public_path__ + "assets/img/paySuccess2.99e3e23a.png";